import { useState } from "react";
import InventoryMovementService from "../../../api/Inventory/InventoryMovementService";
import { MovementResponse } from "../../../api/Inventory/Entities/InventoryMovementEntities";
import useLoading from "../../../components/Common/useLoading";
import { getUsersById } from "../../../api/identity";
import { getProtocol, getVisitsTrackingTimeLineAPI } from "../../../api/protocol";
import { getPatientByMedicalRecord, searchPatients } from "../../../api/database";

export default function useMove(moveId) {
    const [move, setMove] = useState(new MovementResponse())
    const [isLoading, reload] = useLoading({
        onLoad: async () => {
            if (moveId == undefined || moveId == 0) return;
            const result = await InventoryMovementService.GetById(moveId)

            if (result.Succeeded) {
                const move = result.Value
                const usersResponse = (await getUsersById([move.userId])).data;
                const usersMap = new Map(usersResponse.map(user => [user.userId, user]));
                move.user = usersMap.get(move.userId)

                move.assignName = "";
                if (move.assignment.assignmentType == "Protocol" || move.assignment.assignmentType == "ProtocolLaboratoryKit") {
                    try {
                        const protocolResponse = (await getProtocol(move.assignment.assignId)).data
                        move.assignName = protocolResponse.title
                    } catch {
                        move.protocolDeleted = true
                    }
                }
                if (move.destination != null && move.destination.destinationId != null) {
                    const patienId = move.destination.destinationId;
                    const patient = move.destination != null && patienId != null
                        ? (await getPatientByMedicalRecord(patienId))?.data ?? ""
                        : null
                    move.destination = {
                        ...move.destination,
                        destinationName: patient?.fullName ?? null
                    }
                    if (move.destination.patientVisitId != null) {
                        const visitId = move.destination.patientVisitId;
                        const protocolId = move.assignment.assignId;
                        const result = (await searchPatients(patient.fullName))
                            .data

                        //Filtro por los asignados a este protocolo
                        const patientInProtocol = result
                            .find(p => p.medicalRecordNumber == patient.medicalRecordNumber)
                            ?.protocols.find(p => p.id == move.assignment.assignId);


                        if (patientInProtocol?.numberInProtocol != null) {
                            const visits = await getVisitsTrackingTimeLineAPI(protocolId, patientInProtocol.numberInProtocol)
                            const visit = visits.data.find(v => v.id == visitId);
                            move.destination = {
                                ...move.destination,
                                visitTitle: visit?.title
                            }
                        }
                    }
                }

                setMove(move)
            }
        },
        onError: (err) => {
            setMove(new MovementResponse())
        }
    })

    return [move, isLoading, reload]
}